import { useState, useMemo, useCallback } from 'react';

export default function useItemFilters(items = []) {
  const [search, setSearch] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortDir, setSortDir] = useState('newest');

  const filteredItems = useMemo(() => {
    const q = search.trim().toLowerCase();
    const getPrice = item => item.price ?? 0;

    return [...items]
      .filter(item => {
        if (!q) return true;
        return [item.title, item.description].some(f => f?.toLowerCase().includes(q));
      })
      .filter(item => categoryFilter === 'all' || item.category === categoryFilter)
      .filter(item => statusFilter === 'all' || item.status === statusFilter)
      .sort((a, b) => {
        if (sortDir === 'price_asc') return getPrice(a) - getPrice(b);
        if (sortDir === 'price_desc') return getPrice(b) - getPrice(a);
        const diff = new Date(a.created_at) - new Date(b.created_at);
        return sortDir === 'newest' ? -diff : diff;
      });
  }, [items, search, categoryFilter, statusFilter, sortDir]);

  const activeFilterCount = useMemo(() => [
    categoryFilter !== 'all',
    statusFilter !== 'all',
    sortDir !== 'newest',
  ].filter(Boolean).length, [categoryFilter, statusFilter, sortDir]);

  const clearFilters = useCallback(() => {
    setSearch('');
    setCategoryFilter('all');
    setStatusFilter('all');
    setSortDir('newest');
  }, []);

  return {
    filteredItems,
    search, setSearch,
    categoryFilter, setCategoryFilter,
    statusFilter, setStatusFilter,
    sortDir, setSortDir,
    activeFilterCount,
    clearFilters,
  };
}
